export const CONNECTION_ERROR_MESSAGE =
  'No se pudo conectar con el servicio. Comprueba tu conexión y recarga la página.'

const isNetworkError = (error) =>
  error instanceof TypeError ||
  /failed to fetch|networkerror|load failed|network request failed/i.test(error?.message ?? '')

export const installFriendlyFetch = (target = window) => {
  if (!target?.fetch || target.fetch.__friendlyFetch) return

  const originalFetch = target.fetch.bind(target)
  const friendlyFetch = async (...args) => {
    try {
      return await originalFetch(...args)
    } catch (error) {
      if (!isNetworkError(error)) throw error

      const friendlyError = new Error(CONNECTION_ERROR_MESSAGE, { cause: error })
      friendlyError.code = 'CONNECTION_ERROR'
      throw friendlyError
    }
  }

  friendlyFetch.__friendlyFetch = true
  target.fetch = friendlyFetch
}
